import { CANCEL_REMOVE_GIFT_VOUCHER } from 'redux/modules/order/actions/types';

const cancelGiftVoucherToRemove = () => ({
  type: CANCEL_REMOVE_GIFT_VOUCHER,
});

export default cancelGiftVoucherToRemove;
